import { useEffect, useState } from 'react';

import { Builder } from '@builder.io/react';

import { BUILDER_MODELS } from '~/builder/constants/models';
import useBuilderJson from '~/builder/utils/useBuilderJson';
import { useMarketingActions } from '~/techstyle-shared/react-marketing';

function useGlobalReferrerCodes() {
  const builderQuizConfigProperties = {
    modelName: BUILDER_MODELS.HDYH,
  };

  const builderProperties = {
    modelName: BUILDER_MODELS.HDYH,
  };

  if (!Builder.isPreviewing && !Builder.isEditing) {
    builderProperties.options = {
      getAll: true,
    };
  }

  const { builderJson, isLoading } = useBuilderJson(
    builderQuizConfigProperties
  );

  const builderContentLoaded = !isLoading && builderJson;

  return builderContentLoaded ? builderJson?.data?.config : null;
}

export function useBuilderReferrerOptions() {
  const globalCodes = useGlobalReferrerCodes();
  const [options, setOptions] = useState([]);
  const [isUpToDate, setIsUpToDate] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const { loadNestedReferrerOptions } = useMarketingActions();
  useEffect(() => {
    const loadOptions = async () => {
      const result = await loadNestedReferrerOptions(globalCodes);
      setOptions(result.payload);
      setIsUpToDate(true);
      setIsLoading(false);
    };
    if (globalCodes && globalCodes.length > 0 && !isUpToDate) {
      loadOptions();
    }
  }, [globalCodes, loadNestedReferrerOptions, options, isUpToDate, isLoading]);

  return { options, isLoading };
}
